import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import FormGroup from 'components/v2/FormGroup';
import TextAreaForm from 'components/v2/TextAreaForm';
import Helptext from 'components/v2/FormHelptext';
import CargomaticCard from 'components/v2/card';
import InvoiceResults from 'components/modules/tools/components/InvoiceResults';
import Alert from 'components/ui/Alert';

export default function InvoiceDocuments() {
  const { t } = useTranslation();
  const INVOICE_NUMBER_LIMIT = {
    UPPER: 20,
  };
  const [invoiceNumbersText, setInvoiceNumbersText] = useState('');
  const [invoiceNumbers, setInvoiceNumbers] = useState([]);
  const [invoiceNumberCount, setInvoiceNumberCount] = useState(0);

  function onInvoiceNumbersChange(value) {
    setInvoiceNumbersText(value);
    const _invoiceNumberCount = value
      .replace(/\n/g, ',')
      .split(',')
      .filter((number) => number)?.length;
    setInvoiceNumberCount(_invoiceNumberCount);
  }

  function handleSearch() {
    const numbers = invoiceNumbersText
      .replace(/\n/g, ',')
      .split(',')
      .filter((number) => number);

    setInvoiceNumbers(numbers);
  }

  function handleCancel() {
    setInvoiceNumbers([]);
  }
  const isInvoiceNumberLimitInRange =
    invoiceNumberCount > 0 && invoiceNumberCount <= INVOICE_NUMBER_LIMIT.UPPER;

  return (
    <div data-testid="invoicesPanel">
      {invoiceNumbers.length === 0 && (
        <CargomaticCard className="mb-6 max-w-xl">
          <Helptext className="mb-4">
            {t(
              'ENTER_A_LIST_OF_INVOICE_NUMBERS_YOU_WOULD_LIKE_TO_DOWNLOAD_INVOICES_FOR',
            )}
          </Helptext>
          {!!invoiceNumberCount && (
            <Alert
              className="flex-1 mb-2"
              type={invoiceNumberCount > 20 ? 'error' : 'info'}
              title={t('MAX_SEARCH_INVOICE_NUMBER_LIMIT_EXCEEDED_ERROR', {
                current: invoiceNumberCount,
                limit: INVOICE_NUMBER_LIMIT.UPPER,
              })}
            />
          )}
          <FormGroup labelClassName="mb-1" label={t('INVOICE_NUMBERS')}>
            <TextAreaForm
              placeholder={t('COMMA_SEPARATED_VALUES')}
              className="w-full"
              value={invoiceNumbersText}
              onChange={onInvoiceNumbersChange}
              actionName={t('SEARCH')}
              showAction
              rows={4}
              onActionClick={handleSearch}
              disabledBtn={!isInvoiceNumberLimitInRange}
              name="commaSeparatedValues"
            />
          </FormGroup>
        </CargomaticCard>
      )}
      {invoiceNumbers.length > 0 && (
        <InvoiceResults
          invoiceNumbers={invoiceNumbers}
          handleCancel={handleCancel}
        />
      )}
    </div>
  );
}
